export * from './pagination.module';
export * from './pagination.component';


// WEBPACK FOOTER //
// /app/src/app/layout/pagination/index.ts